// src/pages/grupos/CriarGrupo.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import BotaoVoltar from "../../components/BotaoVoltar";
import api from "../../services/api";

export default function CriarGrupo() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nome: "",
    objetivo: "",
    publico: true,
    link_whatsapp: "",
  });

  const [imagemCapa, setImagemCapa] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setImagemCapa(file);
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const data = new FormData();
      data.append("nome", form.nome);
      data.append("objetivo", form.objetivo);
      data.append("publico", form.publico ? "true" : "false");
      data.append("link_whatsapp", form.link_whatsapp);

      if (imagemCapa) {
        data.append("imagem_capa", imagemCapa);
      }

      await api.post("/grupos/criar/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      navigate("/grupos");
    } catch (err) {
      console.error(err);
      alert("Erro ao criar grupo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold mb-0">Criar Novo Grupo</h2>
          <BotaoVoltar to="/grupos" />
        </div>

        <div className="card shadow-sm p-4">
          <form onSubmit={submit}>
            {/* Nome */}
            <div className="mb-3">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                name="nome"
                className="form-control"
                value={form.nome}
                onChange={handleChange}
                required
              />
            </div>

            {/* Objetivo */}
            <div className="mb-3">
              <label className="form-label fw-bold">Objetivo</label>
              <textarea
                name="objetivo"
                rows="4"
                className="form-control"
                value={form.objetivo}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Imagem de capa */}
            <div className="mb-3">
              <label className="form-label fw-bold">Imagem de capa</label>
              <input
                type="file"
                name="imagem_capa"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
              />
              <small className="text-muted">
                Opcional. Use uma imagem em formato JPG ou PNG.
              </small>

              {imagemCapa && (
                <div className="mt-3">
                  <p className="mb-1 small text-muted">Pré-visualização:</p>
                  <img
                    src={URL.createObjectURL(imagemCapa)}
                    alt="Pré-visualização da capa"
                    className="rounded"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>

            {/* Link WhatsApp */}
            <div className="mb-3">
              <label className="form-label fw-bold">Link do WhatsApp</label>
              <input
                type="url"
                name="link_whatsapp"
                className="form-control"
                value={form.link_whatsapp}
                onChange={handleChange}
                placeholder="Opcional"
              />
            </div>

            {/* Público / Privado */}
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                name="publico"
                id="publicoCheck"
                checked={form.publico}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="publicoCheck">
                Grupo público
              </label>
            </div>

            <div className="mb-4">
              <small className="text-muted">
                Este grupo será:{" "}
                <span
                  className={
                    "badge ms-1 " +
                    (form.publico ? "bg-success" : "bg-secondary")
                  }
                >
                  {form.publico ? "Público" : "Privado"}
                </span>
              </small>
            </div>

            <button
              className="btn btn-primary px-4"
              type="submit"
              disabled={submitting}
            >
              {submitting ? "Criando..." : "Criar Grupo"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
